import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            Browse <strong className="text-primary-600">Sugargoo Spreadsheet</strong> Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Select a category below to explore our curated Sugargoo product spreadsheet — updated with the latest finds across all major fashion categories.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-14">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-300 rounded-xl px-5 py-3.5 text-sm text-foreground-800 font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all"
            >
              <option value="">— Select a Category —</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
            </div>
          </div>
          <p className="text-xs text-foreground-400 text-center mt-2">
            Selecting a category will open the spreadsheet on our main website
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer hover:scale-[1.02] transition-all duration-300"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Sugargoo ${cat.name} spreadsheet category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <div className="flex items-center gap-2">
                  <div className="w-7 h-7 flex items-center justify-center bg-background-50/20 backdrop-blur-sm rounded-lg">
                    <i className={`${cat.icon} text-background-50 text-sm`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-semibold text-background-50 whitespace-nowrap">
                    {cat.name}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}